//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProcessPost from "@/components/ProcessPost";
import ProcessPostList from "@/components/ProcessPostList";
import {mapGetters, mapState} from "vuex";

export default {
  data() {
    return {
      processPostList: ProcessPostList
    }
  },
  name: "ProcessInfo",
  components: {
    ProcessPostList,
    ProcessPost,
  },
  computed: {
    ...mapState([ 'manufacturerInfos', 'occupationalSafetyPosts', 'processContentLoading', 'processData']),
    ...mapGetters(['hasManufacturerInfos', 'hasOccupationalSafetyPosts']),
    process() {
      return this.$store.state.selectedProcess
    },
    processContent() {
      console.log("Post:", this.$store.state.processContent)
      return this.$store.state.processContent
    }
  },
  mounted() {
    console.log('ProcessInfo loaded')
  }
}
